import React from 'react';
import {
  DocumentoDashboardItem,
  DocumentoDashboardStatus,
} from '../../../types/documentosDashboard';

interface Props {
  documentos: DocumentoDashboardItem[];
  onOpen: (documento: DocumentoDashboardItem) => void;
}

const statusClasses: Record<DocumentoDashboardStatus, string> = {
  regular: 'bg-green-100 text-green-800',
  vencendo: 'bg-yellow-100 text-yellow-800',
  vencido: 'bg-red-100 text-red-800',
  pendente_validacao: 'bg-blue-100 text-blue-800',
  invalido: 'bg-gray-200 text-gray-700',
};

const statusLabels: Record<DocumentoDashboardStatus, string> = {
  regular: 'Regular',
  vencendo: 'Próximo do vencimento',
  vencido: 'Vencido',
  pendente_validacao: 'Pendente de validação',
  invalido: 'Inválido',
};

const formatDate = (value?: string | null) =>
  value ? new Date(value).toLocaleDateString('pt-BR') : 'Não informada';

const LicenseTable: React.FC<Props> = ({ documentos, onOpen }) => {
  if (documentos.length === 0) {
    return (
      <p className="py-8 text-center text-gray-500">
        Nenhum documento encontrado para os filtros aplicados.
      </p>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white">
        <thead className="bg-gray-50">
          <tr>
            {['Empresa', 'Tipo', 'Número', 'UF', 'Vencimento', 'Status'].map((label) => (
              <th key={label} className="px-4 py-3 text-left text-sm font-semibold text-gray-600">{label}</th>
            ))}
            <th className="px-4 py-3 text-right text-sm font-semibold text-gray-600">Ação</th>
          </tr>
        </thead>
        <tbody>
          {documentos.map((documento) => (
            <tr key={documento.documentoId} className="border-b hover:bg-gray-50">
              <td className="px-4 py-3 text-sm font-medium">{documento.empresaRazaoSocial}</td>
              <td className="px-4 py-3 text-sm">{documento.tipoDocumento}</td>
              <td className="px-4 py-3 text-sm">{documento.numeroDocumento ?? 'Não informado'}</td>
              <td className="px-4 py-3 text-sm">{documento.empresaUf ?? '—'}</td>
              <td className="px-4 py-3 text-sm">{formatDate(documento.dataValidade)}</td>
              <td className="px-4 py-3 text-sm">
                <span className={`inline-block rounded-full px-2 py-1 text-xs font-medium ${statusClasses[documento.status]}`}>
                  {statusLabels[documento.status]}
                </span>
              </td>
              <td className="px-4 py-3 text-right text-sm">
                <button type="button" onClick={() => onOpen(documento)} className="font-medium text-emerald-700 hover:text-emerald-900">
                  Analisar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LicenseTable;
